import {
  SpecialitiesAndCouncils,
  SpecialitiesAndCouncilsResponse,
} from '../scheduled-types'

class GetSpecialitiesAndCouncilsData {
  toDomain(data: SpecialitiesAndCouncilsResponse[]): SpecialitiesAndCouncils[] {
    return data?.map(item => ({
      serviceType: item.tipoServico,
      councilId: item.idConselho,
      specialityId: item.idEspecialidade,
      councilType: item.tipoConselho,
      councilHasImmediate: item.conselhoPossuiAtendimentoAgendado,
      councilHasSchedule: item.conselhoPossuiAtendimentoAgendado,
      description: item.descricao,
      name: item.nome,
      cbo: item.cbo,
      consultValue: item.valorConsulta,
      image: item.imagem,
      linkImage: item.linkImagem,
      linkImageDocpass: item.linkImagemDocpass,
      flagAllowTimeSlot: item.permiteEncaixe,
      flagPediaty: item.flagPediatria,
      flagAllowQueue: item?.permiteFilaEncaixe,
    }))
  }
}

export default new GetSpecialitiesAndCouncilsData()
